import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m43.667 5.255c-1.334 1.836-2.982 4.105-4.711 6.484-3.217-2.341-7.166-3.739-11.45-3.739h-1e-3l1e-3 -8c6.041 0 11.623 1.953 16.161 5.255z",
  fill: "#ffce00"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.62 5.221c-1.33 1.838-2.974 4.111-4.697 6.494 3.227 2.329 5.783 5.647 7.115 9.717l1e-3 1e-3 7.603-2.489c-1.88-5.741-5.474-10.438-10.022-13.723z",
  fill: "#fb9600"
}), /*#__PURE__*/React.createElement("path", {
  d: "m53.654 18.998c-2.158 0.702-4.825 1.569-7.622 2.479 1.234 3.783 1.344 7.971 0.021 12.044v1e-3l7.609 2.47c1.866-5.747 1.731-11.659-8e-3 -16.994z",
  fill: "#e25335"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.673 49.74c-1.334-1.835-2.983-4.104-4.713-6.482 3.221-2.337 5.77-5.661 7.092-9.735l1e-3 -2e-3 7.608 2.473c-1.865 5.744-5.447 10.451-9.988 13.746z",
  fill: "#de349e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m43.667 49.746c-1.334-1.836-2.982-4.105-4.711-6.484-3.217 2.342-7.166 3.739-11.449 3.739h-1e-3l1e-3 8c6.04 0 11.622-1.953 16.16-5.255z",
  fill: "#bf2fdc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.344 49.746c1.334-1.836 2.982-4.105 4.711-6.484 3.217 2.342 7.166 3.739 11.449 3.739h2e-3l-2e-3 8c-6.041 0-11.623-1.953-16.16-5.255z",
  fill: "#5d33d5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.391 49.779c1.33-1.838 2.974-4.111 4.697-6.494-3.227-2.329-5.783-5.646-7.116-9.718v-1e-3l-7.603 2.489c1.88 5.742 5.473 10.44 10.022 13.724z",
  fill: "#2b7cd7"
}), /*#__PURE__*/React.createElement("path", {
  d: "m1.357 36.003c2.158-0.701 4.825-1.569 7.622-2.479-1.234-3.783-1.344-7.97-0.021-12.045l-7.609-2.47c-1.866 5.746-1.732 11.659 8e-3 16.994z",
  fill: "#33c3dd"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.337 5.26c1.334 1.836 2.983 4.104 4.713 6.483-3.221 2.336-5.77 5.661-7.092 9.735v1e-3l-7.608-2.472c1.864-5.745 5.445-10.451 9.987-13.747z",
  fill: "#32d9a1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.344 5.255c1.334 1.836 2.982 4.105 4.711 6.484 3.217-2.341 7.166-3.739 11.449-3.739h1e-3v-8c-6.041 0-11.624 1.953-16.161 5.255z",
  fill: "#3fcb2a"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeType: "xml",
  attributeName: "transform",
  type: "rotate",
  from: "0 27.5 27.5",
  to: "360 27.5 27.5",
  dur: "0.5s",
  repeatCount: "indefinite"
})), 'AnimatedLoadingColorful', {
  viewBox: '0 0 60 60'
});